<template>
  <div class="con-type-example">

    <vs-navbar type="flat" v-model="indexActive" class="nabarx">

      <template #title>
        <router-link :to="{ name:'home' }">
          <vs-navbar-title>
            <span class="clip_chaton10x clip">Chaton10x</span>
            <span class="clip_codeitup_x_chaton10x clip"> X </span>
            <span class="clip_codeitup clip">CodeitUp</span>
          </vs-navbar-title>
        </router-link>
      </template>
      <vs-navbar-item v-for="(item, index) in navbarItems" :key="index" :index="index">
        <router-link :to="{ name: item.routeName }">{{ item.title }}</router-link>
      </vs-navbar-item>
      <vs-navbar-item index="3">
        <router-link v-if="!authStore.isLoggedIn" :to="{ name:'auth' }">Login</router-link>
        <div v-else class="profile-menu">
          <vs-avatar :src="getUserAvatar()" size="small" @click="toggleProfileMenu" />
          <div v-show="showProfileMenu" class="profile-dropdown">
            <router-link :to="{ name:'profile' }" class="dropdown-item">Profile</router-link>
            <div class="dropdown-item logout" @click="handleLogout">Logout</div>
          </div>
        </div>
      </vs-navbar-item>
      <vs-navbar-item style="display: none" index="4">
        <vs-button icon type="flat" size="small" @click="themeStore.toggleTheme">
          <i v-if="themeStore.isDark" class="material-icons" style="font-size: 14px;">light_mode</i>
          <i v-else class="material-icons" style="font-size: 14px;">dark_mode</i>
        </vs-button>
      </vs-navbar-item>
    </vs-navbar>
  </div>
</template>
<style>
@import "../../styles/clip.css";
.nabarx{
  background-color: var(--dark) !important;
  width: 100vw;
  min-height: 48px;
  padding: 0 1rem;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .nabarx{
    padding: 0 0.5rem;
    min-height: 44px;
  }
  .vs-navbar--item {
    font-size: 15px;
    padding: 0 7px;
  }
}

@media (max-width: 500px) {
  .nabarx{
    padding: 0 0.1rem;
    min-height: 40px;
  }
  .vs-navbar--item {
    font-size: 12px;
    padding: 0 4px;
  }
}

.vs-navbar--item {
  color: var(--text-disable) !important;
}
.btn-responsive-line {
  background: var(--text) !important;
}
.vs-navbar-flat {
  border-radius: 0 0 10px 10px;
}
.is-active-item {
  font-family: "Gilroy-Bold",sans-serif;
  color: var(--text) !important;
}

.profile-menu {
  position: relative;
  cursor: pointer;
}

.profile-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: var(--dark);
  border: 1px solid rgba(var(--vs-primary), 0.1);
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.15);
  min-width: 120px;
  z-index: 1000;
  margin-top: 0.5rem;
}

.dropdown-item {
  padding: 0.75rem 1rem;
  color: var(--text);
  display: block;
  text-decoration: none;
  transition: background-color 0.2s;
  
  &:hover {
    background: rgba(var(--vs-primary), 0.1);
  }
  
  &.logout {
    color: var(--danger);
    cursor: pointer;
    
    &:hover {
      background: rgba(var(--vs-danger), 0.1);
    }
  }
}
</style>

<script setup>
import {ref, watchEffect, onMounted, onUnmounted} from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/lib/store/auth.store";
import { useThemeStore } from "@/lib/store/theme.store";
import { jwtDecode } from 'jwt-decode';

const router = useRouter();
const authStore = useAuthStore();
const themeStore = useThemeStore();

const indexActive = ref(0);
const showProfileMenu = ref(false);
const navbarItems = ref([
  { title: 'Home', routeName: 'home' },
  { title: 'Problems', routeName: 'problem' },
  { title: 'Contest', routeName: 'contest' },
]);

// Function to generate avatar URL
const getUserAvatar = () => {
  if (!authStore.accessToken) return '';
  
  try {
    const decoded = jwtDecode(authStore.accessToken);
    const seed = decoded.sub || 'unknown';
    return `https://api.dicebear.com/9.x/rings/svg?seed=${encodeURIComponent(seed)}`;
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return '';
  }
};

const toggleProfileMenu = () => {
  showProfileMenu.value = !showProfileMenu.value;
};

const handleLogout = async () => {
  try {
    await authStore.logout();
    await router.push({ name: 'auth' });
  } catch (error) {
    console.error('Logout error:', error);
  }
  showProfileMenu.value = false;
};

// Close dropdown when clicking outside
const handleClickOutside = (event) => {
  const dropdown = document.querySelector('.profile-menu');
  if (dropdown && !dropdown.contains(event.target)) {
    showProfileMenu.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

watchEffect(() => {
  const newIndex = navbarItems.value.findIndex((item) => item.routeName === router.currentRoute.value.name);
  if(newIndex !== -1){
    indexActive.value = newIndex;
  }
});

</script>
